import { ref, computed } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

// const discoveryOptions = computed(() => store.state.general.enums['DiscoveryMode'] || [])

const discoveryOptions = computed(() => store.state.general.enums['DiscoveryMode'] || [])
const realOptions = computed(() => discoveryOptions.value.filter(opt => opt.label !== 'Enable All'))

function getDiscoveryLabels(value: string | number): string[] {
  if (!value) return [];

  let total = 0;

  if (typeof value === "string") {
    total = value
      .split(",")
      .map((v) => parseInt(v.trim(), 10))
      .reduce((acc, val) => acc + val, 0);
  } else {
    total = value;
  }

  return realOptions.value
    .filter((opt) => {
      if (typeof opt.value === "string" && opt.value.includes("|")) {
        const keys = opt.value.split("|").map((k) => parseInt(k, 10));
        return keys.every((k) => (total & k) === k);
      }
      return (total & Number(opt.value)) !== 0;
    })
    .map((opt) => opt.label);
}

function getFolderNameById(value: number): string | undefined {
  const folderMaps = computed(() => store.state.general.folderMaps as { label: string; value: number }[]);
  const folder = folderMaps.value.find((item: any) => item.value === value);
  return folder?.label;
}

function escapeHtml(text: string): string {
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

declare global {
  interface Window {
    AGSC_toggleApps?: (el: HTMLElement) => void;
  }
}
if (typeof window !== "undefined") {
  window.AGSC_toggleApps = (el: HTMLElement) => {
    try {
      const ul = el.closest('ul');
      if (!ul) return;

      const encoded = ul.getAttribute('data-list') || el.getAttribute('data-list') || '';
      const list = decodeURIComponent(encoded).split('|').map(s => s.trim()).filter(Boolean);
      const expanded = ul.getAttribute('data-expanded') === '1';

      if (!expanded) {
        const html =
          list.map(app => `<li>${escapeHtml(app)}</li>`).join('') +
          `<li style="list-style:none;margin-left:0;">
             <a href="#" style="color#5d5f62;font-weight:700;text-decoration:none;"
                onclick="AGSC_toggleApps(this);return false;">Show less</a>
           </li>`;
        ul.innerHTML = html;
        ul.setAttribute('data-expanded', '1');
      } else {
        const visible = list.slice(0, 3);
        const hiddenCount = Math.max(0, list.length - 3);
        const fullListText = list.join(', ');
        const encodedList = encodeURIComponent(list.join('|'));

        const visibleLis = visible.map(app => `<li>${escapeHtml(app)}</li>`).join('');
        const hiddenIndicator = hiddenCount > 0
          ? `<li style="list-style:none;margin-left:0;">
               <a href="#" class="more-badge"
                  style="color:#5d5f62;font-weight:700;text-decoration:none;"
                  title="${escapeHtml(fullListText)}"
                  data-list="${encodedList}"
                  onclick="AGSC_toggleApps(this);return false;">+${hiddenCount} more</a>
               <span style="position:absolute;left:-9999px;top:auto;width:1px;height:1px;overflow:hidden;">${escapeHtml(fullListText)}</span>
             </li>`
          : '';
        ul.innerHTML = `${visibleLis}${hiddenIndicator}`;
        ul.setAttribute('data-expanded', '0');
      }
    } catch {
      console.error('Failed to toggle apps');
    }
  };
}
const data = {
  filter: {
    title: "",
    pageName: "",
    genre: "",
    ignoreSaveFilter: true,
    noDateSelect: true,
    hideFilter: false,
    //quickSearch: "fullTextSearch",
    filters: [
    ],
  },
  header: {
    navigation: [

    ],
    buttonPosition: "pr-4 justify-content-between",
    buttons: [

    ],
  },
  component: {
    type: "ag-table",
    name: "appManagementTable",
    options: {
      columns: [
        {
          label: "APP GROUP",
          field: "name",
          sortable: true,
          jsSort: true,
          tooltip: 'bottom',
          truncate: {
            position: "bottom",
            first: 6,
            last: 6,
            tableShow: function (row: any) {
              let label = "";
              if (row.info) {
                label = '<i class="ag-icon ag-icon_table_info mr-1" style="font-size:0.7em !important;"></i>';
              }
              const statusChip = row.enabled
              ? "<span style='margin-left:8px;background:#35B90733;color:#31AA06;border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'><span style='width:6px;height:6px;background:#31AA06;border-radius:50%;display:inline-block;margin-right:3px;'></span>On</span>"
              : "<span style='margin-left:8px;background:#D0D7E0;color:#838A92;border-radius:16px;padding:2px 8px;font-weight:700;font-size:12px;display:inline-flex;align-items:center;'><span style='width:6px;height:6px;background:#838A92;border-radius:50%;display:inline-block;margin-right:3px;'></span>Off</span>";

              
              return (
                "<div class='d-flex align-items-center'> " +
                "<span>" +
                label +
                "</span>"
                +
                " <span style='color: #01172F; font-weight: bold; margin-left: 5px;'>" +
                row.name +
                " " + statusChip + "</div>"
              );
            },
            show: function (row: any) {
              return (
                "<span>" +
                row.description +
                "</span>"
              );
            },
          },
          width: "40%",
        },
        {
          label: "APPLICATION LIST",
          field: "applications",
          display: (row: any) => {
            const rawList = (row.appGroupProcess?.map((proc: any) => {
              return proc.fileName || getFolderNameById(proc.folderMapId);
            }) || []).filter((v: any) => !!v) as string[];

            const appList = rawList.map(v => (v && v.length > 50 ? v.slice(0, 47) + "..." : v));

            const visible = appList.slice(0, 3);
            const hidden = appList.slice(3);
            const fullListText = rawList.join(", ");
            const encodedList = encodeURIComponent(rawList.join("|"));

            const visibleLis = visible.map(app => `<li>${escapeHtml(app)}</li>`).join("");
            const hiddenIndicator = hidden.length > 0
              ? `<li style="list-style: none; margin-left: 0;">
       <a href="#" class="more-badge"
          style="color:#5d5f62; font-weight:700; text-decoration:none;"
          title="${escapeHtml(fullListText)}"
          data-list="${encodedList}"
          onclick="AGSC_toggleApps(this); return false;">+${hidden.length} more</a>
       <span style="position:absolute; left:-9999px; top:auto; width:1px; height:1px; overflow:hidden;">${escapeHtml(fullListText)}</span>
     </li>`
              : "";

            return `<ul data-list="${encodedList}" data-expanded="0" style="padding-left: 1.25rem; margin: 0; color: #01172F">${visibleLis}${hiddenIndicator}</ul>`;
          },
          sortable: false,
          width: "25%",
        },
        {
          label: "DISCOVERY MODE",
          field: "subsystemsInDiscoveryMode",
          display: (row: any) => {
            const discoveryList = getDiscoveryLabels(row.subsystemsInDiscoveryMode)
            return `<ul style="padding-left: 1.25rem; margin: 0; color: #01172F">
        ${discoveryList.map((item) => `<li>${item}</li>`).join("")}
      </ul>`;
          },
          sortable: false,
          width: "25%",
        },
        {
          label: "ACTION",
          field: "commands",
          justify: 'justify-content-center',
          style: { justifyItems: 'center' },
          components: [
            {
              component: "tableNextPageComponent",
              class: "mr-2 ml-2",
            },
            {
              component: "appGroupDeleteComponent",
              class: "mr-2 ml-2",
            },
          ],
          width: "10%",

        },
      ],
      rows: [],
      total: 0,
      sortable: {
        order: "name",
        sort: "",
      },
      page: 0,
      pageSize: 0,
      isLoading: true,
      showPagination: false,
      dateFilter: false,
      zebra: true,
      separateBorders: true,
      editOnRowClick: true,
      fetchTable: (options: any) => {
        store.dispatch(GeneralActionTypes.GET_APPGROUPS, {
          options: options,
          filters: {}
        });
      },
    },
  },

};

export default data;
